<template>  
    <section class="block block--projectslider">
        <div
            v-for="(project, index) in filteredProjects"
            :key="index"
            class="slide position-relative">
            <router-link :to="`/projects/${project.slug}`">             
                <div
                    v-if="project.image"
                    class="project-slider__img"
                    :style="{ backgroundImage: `url('${$VUE_APP_API_URL + project.image.url}')` }"
                    :alt="project.image.caption">
                    <div class="project-slider__img--overlay"></div>
                </div>
            </router-link>
            <div class="container h-100">
                <div class="row h-100">
                    <div class="d-none d-md-block col-md-6">
                    </div>
                    <div class="col-md-6 project-slider__content">
                        <div class="project-slider__index">{{ index + 1 }}/{{ filteredProjects.length }}</div>
                        <h2 v-if="project.title">{{ project.title }}</h2>
                        <div v-if="project.subtitle" class="subtitle">{{ project.subtitle }}</div>
                        <div v-if="project.description" v-html="project.description"></div>
                        <div class="mt-1">
                            <router-link class="btn btn-primary" :to="`/projects/${project.slug}`">
                                Learn More
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default { 
    name: 'projectslider',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    },

    computed: {
        filteredProjects() {
            return this.block.projects.filter(p => p.active).sort((a, b) => {
                return a.order - b.order
            })
        }
    }
}
</script>